
const isPro = Object.is(process.env.NODE_ENV, 'production')

export default {
  baseUrl: isPro ? '/webApi' : '/webApi'
}



// WEBPACK FOOTER //
// ./config/api.config.js